import { createSlice } from "@reduxjs/toolkit";
import addCaseTiming from "@custom/rtk-apis/Setting/addCaseTiming";

const initialState = {
    status: "",
    result: {},
    msg: "",
    loading: false,
    error: ""
};

const addCaseTimingSlice = createSlice({
    name: "addCaseTimingSlice",
    initialState,
    reducers: {
        clearAddCaseTimingState: (state: any) => {
            state.status = '';
            state.result = {};
            state.msg = '';
            state.loading = false;
            state.error = '';
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addCaseTiming.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(addCaseTiming.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.status = payload.status;
                state.result = payload.result;
                state.msg = payload.msg;
            })
            .addCase(addCaseTiming.rejected, (state, { payload }) => {
                state.result = payload;
                state.loading = false;
            });
    },
});

export default addCaseTimingSlice.reducer;
export const { clearAddCaseTimingState } = addCaseTimingSlice.actions;
